import { cn } from '@rematter/ui-web';
export type WindowsIconProps = { className?: string };

export const WindowsIcon = (props: WindowsIconProps) => (
  <svg
    className={cn('@WindowsIcon', props.className)}
    role="img"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0,0H11.377V11.372H0ZM12.623,0H24V11.372H12.623ZM0,12.623H11.377V24H0Zm12.623,0H24V24H12.623" />
  </svg>
);
